export var idToUuid = function (id) {
    if (id === void 0) { id = ''; }
    return "".concat(id.substr(0, 8), "-").concat(id.substr(8, 4), "-").concat(id.substr(12, 4), "-").concat(id.substr(16, 4), "-").concat(id.substr(20));
};
//# sourceMappingURL=id-to-uuid.js.map